import { ReactPart } from '../react';
export class ReactTabGroupChipPart {
    get element() {
        return this._element;
    }
    constructor(component, reactPortalStore) {
        this.component = component;
        this.reactPortalStore = reactPortalStore;
        this._element = document.createElement('div');
        this._element.className = 'dv-react-part';
        this._element.style.display = 'inline-flex';
    }
    init(params) {
        this.part = new ReactPart(this._element, this.reactPortalStore, this.component, {
            tabGroup: params.tabGroup,
            api: params.api,
        });
    }
    update(params) {
        var _a;
        (_a = this.part) === null || _a === void 0 ? void 0 : _a.update({ tabGroup: params.tabGroup });
    }
    dispose() {
        var _a;
        (_a = this.part) === null || _a === void 0 ? void 0 : _a.dispose();
    }
}
